import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AdminProvider } from './context/AdminContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AskAi } from './components/AskAi';
import { Login } from './pages/Login';
import { ForgotPassword } from './pages/ForgotPassword';
import { Dashboard } from './pages/Dashboard';
import { MyWells } from './pages/MyWells';
import { CompaniesHome } from './pages/CompaniesHome';
import { Profile } from './pages/Profile';
import { KnowledgeBase } from './pages/KnowledgeBase';
import { LayoutAdmin } from './pages/LayoutAdmin';
import { AdminIndex } from './pages/admin/AdminShell';
import { Companies } from './pages/admin/Companies';
import { Wells } from './pages/admin/Wells';
import { Roles } from './pages/admin/Roles';
import { Layouts } from './pages/admin/Layouts';
import { Users } from './pages/admin/Users';

/** The admin area, in the order its tabs appear. Each page checks who may open it. */
const ADMIN_PAGES = [
  { path: '/web/Admin', element: <AdminIndex /> },
  { path: '/web/Admin/Companies', element: <Companies /> },
  { path: '/web/Admin/Wells', element: <Wells /> },
  { path: '/web/Admin/Roles', element: <Roles /> },
  { path: '/web/Admin/Layouts', element: <Layouts /> },
  { path: '/web/Admin/Layout', element: <LayoutAdmin /> },
  { path: '/web/Admin/Users', element: <Users /> },
];

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AdminProvider>
          <Routes>
            <Route path="/" element={<Navigate to="/web" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route
              path="/web"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/web/Companies"
              element={
                <ProtectedRoute>
                  <CompaniesHome />
                </ProtectedRoute>
              }
            />
            <Route
              path="/web/MyWells"
              element={
                <ProtectedRoute>
                  <MyWells />
                </ProtectedRoute>
              }
            />
            <Route
              path="/web/UserProfile/EditProfile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/web/KnowledgeBase"
              element={
                <ProtectedRoute>
                  <KnowledgeBase />
                </ProtectedRoute>
              }
            />

            {ADMIN_PAGES.map((page) => (
              <Route key={page.path} path={page.path} element={<ProtectedRoute>{page.element}</ProtectedRoute>} />
            ))}

            <Route path="*" element={<Navigate to="/web" replace />} />
          </Routes>

          {/*
            Outside <Routes> on purpose: mounted here the assistant survives every
            navigation, so the conversation is still there after a trip to My
            Wells. Inside a route it would be torn down and forget it.
          */}
          <AskAi />
        </AdminProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
